import type { ReactElement } from 'react'

const FIELD_CLASS =
  'w-full rounded-lg border border-stone-300 px-3 py-2 text-sm focus:border-[#4e5e82] focus:outline-none focus:ring-1 focus:ring-[#4e5e82] dark:border-stone-600 dark:bg-stone-700 dark:text-white'
const LABEL_CLASS = 'mb-1 block text-sm font-medium text-stone-600 dark:text-stone-400'

type ChangeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void

interface SelectFieldProps {
  id: string
  name: string
  value: string
  label: string
  required?: boolean
  options: { value: string; label: string }[]
  onChange: ChangeHandler
}

export function SelectField({
  id,
  name,
  value,
  label,
  required,
  options,
  onChange,
}: SelectFieldProps): ReactElement {
  return (
    <div>
      <label htmlFor={id} className={LABEL_CLASS}>
        {label}
        {required ? ' *' : ''}
      </label>
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className={FIELD_CLASS}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

interface MoneyFieldProps {
  id: string
  name: string
  value: string
  label: string
  onChange: ChangeHandler
}

export function MoneyField({ id, name, value, label, onChange }: MoneyFieldProps): ReactElement {
  return (
    <div>
      <label htmlFor={id} className={LABEL_CLASS}>
        {label}
      </label>
      <input
        type="number"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        min="0"
        step="0.01"
        className={FIELD_CLASS}
      />
    </div>
  )
}
